<template>
    <main-content>
        <div class="clearfix">
            <button class="btn btn-primary m-2 float-right" data-toggle="modal" data-target="#description_modal">
                {{ $t('label.add_new_user') }}
            </button>
            <router-link class="kt-nav__link m-2 btn btn-outline-primary float-right" to="/users-categories">
                {{ $t('label.categorize-users') }}
            </router-link>
            <router-link class="kt-nav__link m-2 btn btn-outline-primary float-right" to="/users-club-events">
                {{ $t('aside.users_club_events') }}
            </router-link>
            <div id="description_modal" class="modal fade rtl" role="dialog">
                <div class="modal-dialog">
                    <!-- Modal content-->
                    <div class="modal-content">
                        <div id="data_sheet" class="modal-body mb-4">
                            <div class="modal-header">
                                <h4 class="modal-title">ثبت کاربر جدید</h4>
                                <button type="button" class="close" data-dismiss="modal">&times;</button>
                            </div>
                            <div class="m-4">
                                <form @submit.prevent="registerNewUser" method="post">
                                    <kt-form-section>
                                        <kt-form-row>
                                            <kt-col xs="12" sm="6" md="6">
                                                <kt-form-group>
                                                    <kt-form-label for="user_type">
                                                        {{ $t('user_types.label.please_select_user_type') }}
                                                    </kt-form-label>
                                                    <select size="1" id="user_type" class="form-control" name="user_type"
                                                            v-model="new_user.user_type">

                                                        <option
                                                                v-for="(user_type, index) in userTypes" :key="index" :value="user_type"
                                                        >
                                                            {{ userTypesStr.get(user_type) }}
                                                        </option>
                                                    </select>
                                                </kt-form-group>
                                            </kt-col>
                                        </kt-form-row>
                                        <kt-form-row v-if="new_user.user_type === userTypes.REAL">
                                            <kt-col xs="12" sm="6" md="10">
                                                <kt-form-group>
                                                    <kt-form-label for="first_name">
                                                        {{ $t('label.first_name') }}
                                                    </kt-form-label>
                                                    <kt-form-control ref="first_name" dir="ltr" name="first_name"
                                                                     id="first_name" v-model="new_user.first_name"/>
                                                </kt-form-group>
                                            </kt-col>
                                        </kt-form-row>
                                        <kt-form-row v-if="new_user.user_type === userTypes.REAL">
                                            <kt-col xs="12" sm="6" md="10">
                                                <kt-form-group>
                                                    <kt-form-label for="last_name">
                                                        {{ $t('label.last_name') }}
                                                    </kt-form-label>
                                                    <kt-form-control ref="last_name" dir="ltr" name="last_name"
                                                                     id="last_name" v-model="new_user.last_name"/>
                                                </kt-form-group>
                                            </kt-col>
                                        </kt-form-row>
                                        <kt-form-row v-if="new_user.user_type === userTypes.LEGAL">
                                            <kt-col xs="12" sm="6" md="10">
                                                <kt-form-group>
                                                    <kt-form-label for="com_name_fa">
                                                        {{ $t('label.com_name_fa') }}
                                                    </kt-form-label>
                                                    <kt-form-control ref="com_name_fa" dir="ltr" name="com_name_fa"
                                                                     id="com_name_fa" v-model="new_user.com_name_fa"/>
                                                </kt-form-group>
                                            </kt-col>
                                        </kt-form-row>
                                        <kt-form-row>
                                            <kt-col xs="12" sm="6" md="10">
                                                <kt-form-group>
                                                    <kt-form-label for="phone">
                                                        {{ $t('label.phone') }}
                                                    </kt-form-label>
                                                    <kt-form-control ref="phone" dir="ltr" name="phone" id="phone"
                                                                     v-model="new_user.phone"/>
                                                </kt-form-group>
                                            </kt-col>
                                        </kt-form-row>
                                        <kt-form-row>
                                            <kt-col xs="12" sm="6" md="10">
                                                <kt-form-group>
                                                    <kt-form-label for="password">
                                                        {{ $t('label.password') }}
                                                    </kt-form-label>
                                                    <kt-form-control ref="password" dir="ltr" name="password"
                                                                     id="password" v-model="new_user.password"/>
                                                </kt-form-group>
                                            </kt-col>
                                        </kt-form-row>
                                        <kt-form-row>
                                            <kt-col xs="12" sm="6" md="6">
                                                <kt-form-group>
                                                    <kt-form-label for="status">
                                                        {{ $t('label.status') }}
                                                    </kt-form-label>
                                                    <select size="1" id="status" class="form-control" name="status"
                                                            v-model="new_user.status">
                                                        <option
                                                                v-bind:key="index"
                                                                v-for="(status, index) in statuses"
                                                                v-bind:value="status.value"
                                                        >
                                                            {{ status.name }}
                                                        </option>
                                                    </select>
                                                </kt-form-group>
                                            </kt-col>
                                        </kt-form-row>
                                    </kt-form-section>
                                    <kt-form-section>
                                        <kt-row>
                                            <kt-col xs="12" sm="6" md="6">
                                                <button
                                                        class="btn btn-success btn-wide float-left"
                                                        size="md"
                                                        type="submit"
                                                        id="reg_btn"
                                                >
                                                    {{$t('auth.btn.submit_user')}}
                                                </button>
                                            </kt-col>
                                        </kt-row>
                                    </kt-form-section>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>




      <ul class="nav nav-pills" role="tablist">
        <li class="nav-item" @click="changeBoard(1)">
          <router-link :class="['nav-link', tab == 'user-list' ? 'active' : '']"
                       to="/users/user-list" data-toggle="tab" role="tab" aria-selected="false" style="cursor:pointer;">
            {{ $t('dashboard.label.user_list') }}
          </router-link>
        </li>
        <li class="nav-item" @click="changeBoard(0)">
          <router-link :class="['nav-link', tab == 'excels-list' ? 'active' : '']"
                       to="/users/excels-list" data-toggle="tab" role="tab" aria-selected="false"
                       style="cursor:pointer;" v-if="$can('export-excel','user')"
          >
            {{ $t('dashboard.label.excel_exports_list') }}
          </router-link>
        </li>
      </ul>

      <div class="tab-content">
        <div v-if="current_user.permissions.length > 0" id="user-list" :class="['tab-pane', tab == 'user-list' ? 'active' : '']">
          <user-filter :action="filterAction" form_id=""></user-filter>
          <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
        </div>
        <div id="excels-list" :class="['tab-pane', tab == 'excels-list' ? 'active' : '']" v-if="$can('export-excel','user')">
          <user-filter v-if="$can('user', 'read')" :action="exportToExcel"
                                               :query="query_filter_excel" :form_id="excel_filter_form_id"></user-filter>
          <div class="fh-datatable bg-white" v-if="status === 'success'">
            <table v-if="excelRequests.data.length > 0" class="table table-light-bordered">
              <thead>
              <tr style="font-size: 0.89rem;">
                <td style="text-align: center; width:70px">#</td>
                <td style="text-align: center">{{ $t('label.from_date') }}</td>
                <td style="text-align: center">{{ $t('label.to_date') }}</td>
                <td>{{ $t('label.status') }}</td>
                <td style="text-align: center">عملیات</td>
              </tr>
              </thead>
              <tbody>
              <tr v-bind:key="index" v-for="(req, index) in excelRequests.data">
                <td style="text-align: center">{{ req.id }}</td>
                <td style="text-align: center">{{ req.from_date }}</td>
                <td style="text-align: center">{{ req.to_date }}</td>
                <td style="text-align: center" class="text-center">
                  <div class="text-white" :class="excelStatusVariant(req.status)">
                    {{ excelStatusStr(req.status) }}
                  </div>
                </td>
                <td class="text-center d-flex justify-content-center align-items-center">
                  <a v-show="req.url" :href="req.url" type="button"
                     style="background: none; border: none; color: #7878e4">
                    <i class="fa fa-download"></i>
                  </a>
                  <button @click="handleReqDelete(req.id)"
                          style="background: none; border: none; color: #c90000">
                    <i class="fa fa-trash"></i>
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
            <div v-if="excelRequests.data.length > 0" class="pager kt-datatable--paging-loaded">
              <div class="paginationR">
                <button class="btn-link" title="اولی" @click="changePage(1)">
                  &laquo;&laquo;
                </button>
                <button class="btn-link" title="قبلی" @click="changePage(excelRequests.current_page - 1)">
                  &laquo;
                </button>
                <span
                    v-for="(page, index) in ((excelRequests.current_page) - 2, excelRequests.current_page + 2)"
                    :key="index">
                                <button
                                    v-if="(page <= excelRequests.last_page) && page > excelRequests.current_page - 3"
                                    @click="changePage(page)" :id="'page_' + page"
                                    :class="{ 'active': (excelRequests.current_page == index + 1) }">
                                    {{ page }}
                                </button>
                            </span>
                <button class="btn-link" title="بعدی" @click="changePage(excelRequests.current_page + 1)">
                  &raquo;
                </button>
                <button class="btn-link" title="آخری" @click="changePage(excelRequests.last_page)">
                  &raquo;&raquo;
                </button>
              </div>
              <div class="pager-info">
                <select class="mr-3 ml-3 kt-datatable__pager-size" style="width: 60px;" title="اندازه صفحه"
                        @change="changePage(excelRequests.current_page)" id="perpage-value" v-model="per_page">
                  <option value="15">15</option>
                  <option value="20">20</option>
                  <option value="30">30</option>
                  <option value="50">50</option>
                </select>
                <span class="kt-datatable__pager-detail">
                                {{ 'نمایش ' + excelRequests.from + ' - ' + excelRequests.to + ' از ' +
                excelRequests.total }}
                            </span>
              </div>
            </div>
            <div v-else class="text-center p-5 my-3">
              درخواست خروجی اکسل برای شما وجود ندارد!
            </div>
          </div>
          <div class="loader" style="display:none"></div>
        </div>
      </div>
    </main-content>
</template>

<script>
import $ from "jquery";
import mainContent from "@/components/main-content";
import {mapGetters} from "vuex";
import columns from "./datatable/columns";
import {ApiUrl, openBankingService, transactionService, userService} from "@/common/api.service";
import {AuthorizationHeader} from "@/common/jwt.service";
import {userStatus, userStatusStr} from '@/constants/userStatus'
import {userTypes, userTypesStr} from '@/constants/userTypes';
import {actionsColumn, userFilter} from "./components";
import axios from "axios";
import {KTApp} from '@/plugins/core/app'
import {i18n} from "@/plugins/i18n";

// import { KTUtil } from '@/plugins/core/app'
export default {
  components: {
    mainContent,
    userFilter
  },

  data() {
    return {
      statuses: [
        {
                        name: null,
                        value: null
                    },
                    {
                        name: userStatusStr.ACTIVE,
                        value: userStatus.ACTIVE
                    },
                    {
                        name: userStatusStr.REMOVED,
                        value: userStatus.REMOVED
                    },
                    {
                        name: userStatusStr.PENDING,
                        value: userStatus.PENDING
                    },
                    {
                        name: userStatusStr.IS_AUTHENTICATED,
                        value: userStatus.IS_AUTHENTICATED
                    },
                    {
                        name: userStatusStr.IS_AUTHENTICATED_PENDING,
                        value: userStatus.IS_AUTHENTICATED_PENDING
                    },
                    {
                      name: userStatusStr.USER_INQUIRY_REJECTED,
                      value: userStatus.USER_INQUIRY_REJECTED
                    },
                    {
                      name: userStatusStr.DEACTIVATED,
                      value: userStatus.DEACTIVATED
                    },
                ],
                headerAction: {
                    left: "10px",
                    top: "10px",
                    position: "absolute",
                },
                per_page: 15,
                query: {newsid: 2},
                userTypes,
                userTypesStr,
                query_filter_excel: {},
                excel_filter_form_id: 'excel',
            };
        },
        computed: {
            ...mapGetters('user', [
              'current_user', 'new_user', 'status', 'excelRequests'
            ]),
            tab() {
              if (this.$route.params.tab) {
                return this.$route.params.tab;
              }

              return 'user-list';
            },
            datatableProps() {
                return {
                    id: "user_datatable",
                    data: {
                        type: "remote",
                        source: {
                            read: {
                                url: this.$route.params.newsid
                                    ? ApiUrl.path(
                                        "news/users/see?newsid=" + this.$route.params.newsid + ""
                                    )
                                    : ApiUrl.path("user"),
                                method: "GET",
                                headers: AuthorizationHeader,
                                map: function (res) {
                                    return res.data.data;
                                },
                                params: {
                                    query: this.query,
                                },
                            },
                        },
                        pageSize: 10,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                    },
                    layout: {},
                    pagination: false,
                    sortable: true,
                    columns: columns,
                    actions: actionsColumn,
                };
            },
        },
        methods: {
            filterAction(e, query) {
                this.query = query;
                if (this.$refs.datatable.KTDatatable) {
                    this.$refs.datatable.reload();
                }
            },
            handleReqDelete(hashid) {
              transactionService.deleteCoreExcelRequest(hashid)
                  .then(response => {
                    this.$store.dispatch('user/fetchCoreExcelRequests', this.params).finally(() => {
                      localStorage.setItem('excelRequests_per_page', this.excelRequests.per_page)
                    })
                    this.toastr.success(response.data.message);
                  })
                  .catch(({ response }) => {
                    this.toastr.error(response.data.message);
                  })
            },
            fillParams() {
              this.params = {
                page: this.page,
                perpage: this.per_page,
                type: 'user',
              }
            },
            changePage(pagee) {
              this.page = pagee
              this.fillParams()
              this.$store.dispatch('user/fetchCoreExcelRequests', this.params).finally(() => {
                localStorage.setItem('excelRequests_per_page', this.excelRequests.per_page)
              })
            },
            excelStatusVariant(status) {
              if (status == "CREATED")
                return "badge badge-secondary"

              if (status == "PROCESSING")
                return "badge badge-warning"

              if (status == "PROCESSED")
                return "badge badge-success"
            },
            excelStatusStr(status) {
              if (status == "CREATED")
                return i18n.t('transaction.excelStatus.created')

              if (status == "PROCESSING")
                return i18n.t('transaction.excelStatus.processing')

              if (status == "PROCESSED")
                return i18n.t('transaction.excelStatus.processed')
            },
            changeBoard(board) {
              this.board = board;
            },
            exportToExcel(e, query) {
              query.type = this.params.type;
              let btn = $(e.target);
              let form = $('#user-filter-form' + this.excel_filter_form_id)

              form.validate({
                rules: {
                  from_date: {
                    required: true,
                  },
                  to_date: {
                    required: true,
                  },
                },
              });

              if (!form.valid()) {
                return;
              }

              KTApp.progress(btn)

              this.query_filter_excel = query

              userService.createCoreExcelRequest({
                ...this.query_filter_excel
              }).then(async (response) => {
                await this.$store.dispatch('user/fetchCoreExcelRequests', this.params)
                this.toastr.success(response.data.message)
              }).catch(({ response }) => {
                form.validate().showErrors(response.data.data)
              }).finally(() => {
                KTApp.unprogress(btn)
              });
            },
            registerNewUser(e) {
              let form = $(e.target)
              form.validate().resetForm();
              if (!this.checkFormValidate(form)) {
                return;
              }
              let btn = $('#reg_btn')
              KTApp.progress(btn)

              userService.registerUserByAdmin(this.new_user)
                  .then(response => {
                    KTApp.unprogress(btn)
                    $('#description_modal').modal('hide')
                    this.$refs.datatable.reload();
                    this.clearFormData();
                    })
                    .catch(({response}) => {
                        if (response.data) {
                            form.validate().showErrors(response.data.data)
                        }
                        KTApp.unprogress(btn)
                        this.showMsg(form, 'danger', response.data.message)
                    })
                    .finally(() => {
                      // KTUtil.scrollTop()
                      KTApp.unprogress(btn)
                    })
            },
          clearFormData() {
            const vm = this;
            Object.keys(this.new_user).forEach(function (key) {
              vm.new_user[key] = ''
            });
          },
          checkFormValidate(form) {
            let validator = form.validate();
            if (!this.checkValidatePhone(this.new_user.phone)) {
              validator.showErrors({
                phone: i18n.t('pos.validations.phone_number')
              })
              return false;
            }
            if (!this.checkIfIsPersian(this.new_user.first_name)) {
              validator.showErrors({
                first_name: i18n.t('pos.validations.enter_persian')
              })

              return false;
            }
            if (!this.checkIfIsPersian(this.new_user.last_name)) {
              validator.showErrors({
                last_name: i18n.t('pos.validations.enter_persian')
              })
              return false;
            }
            return true;
          }

        },

        mounted() {
          this.fillParams()
          this.$store.dispatch('user/fetchCoreExcelRequests', this.params).finally(() => {
            localStorage.setItem('excelRequests_per_page', this.excelRequests.per_page)
          })
        }
    };
</script>

<style>
</style>
